<template>
    <div class="interaction-minimum-time">
        <section class="interaction-minimum-time-enable">
            <v-checkbox
                class="interaction-option-enable-checkbox"
                v-model="isMinimumTimeConfigured"
                :ripple="false"
                hide-details
            ></v-checkbox>
            <h6 class="minimum-time-checkbox-title">
                Definir tempo de exibição
            </h6>
        </section>
        <section v-if="isMinimumTimeConfigured">
            <div class="minimum-time-card">
                <span>Exibir por no mínimo</span>
                <input
                    v-model="minimumTime"
                    type="number"
                    class="minimum-time-input"
                    @blur="emitForm"
                    min="0"
                    max="60"
                />
                <span>segundos</span>
            </div>
            <span
                v-if="minimumTimeError"
                class="text-danger minimum-time-error"
                v-html="minimumTimeError"
            ></span>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        interaction: {
            type: Object,
        },
    },
    data() {
        return {
            isMinimumTimeConfigured: false,
            minimumTime: 0,
            minimumTimeError: "",
        };
    },

    watch: {
        isMinimumTimeConfigured(value) {
            if (!this.minimumTime && !value) return;

            if (!value) {
                this.minimumTime = 0;
                this.emitForm();
            }
        },
        minimumTime(value) {
            this.minimumTimeError = "";

            if (!value) return;

            const numberMinimumTime = Number(value);

            if (/[.,]/g.test(value)) {
                this.minimumTimeError =
                    "O tempo mínimo deve ser um valor inteiro.";
            }

            if (numberMinimumTime > 60) {
                this.minimumTimeError = `O limite para campanha de ${this.interaction.tipo.toLowerCase()} é de <b>60</b> segundos.`;
            }

            if (numberMinimumTime < 0) {
                this.minimumTime = 0;
            }
        },
    },

    methods: {
        emitForm() {
            if (this.minimumTimeError) return;

            if (this.minimumTime === "") {
                this.minimumTimeError = "Coloque um valor válido entre 0 e 60.";
                return;
            }

            this.$emit("input", {
                minimumTime: this.minimumTime,
                tipo: "BANNER",
            });
        },
    },

    mounted() {
        if (this.interaction.minimumTime) {
            this.isMinimumTimeConfigured = true;
            this.minimumTime = this.interaction.minimumTime;
        }
    },
};
</script>

<style lang="scss" scoped>
.interaction-minimum-time {
    display: flex;
    flex-direction: column;

    .interaction-minimum-time-enable {
        display: flex;
        align-items: center;
        justify-content: start;
    }

    .interaction-option-enable-checkbox {
        flex: 0;
        padding: 0;
        h6 {
            margin-bottom: 0;
        }
    }
}

.minimum-time-card {
    display: flex;
    align-items: center;
    font-size: 14px;
}

.minimum-time-input {
    padding: 2px;
    border-bottom: 1px solid black;
    max-width: 32px;
    margin-inline: 8px;
    text-align: center;
    font-size: 14px;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &:focus {
        outline: none;
    }

    input[type="number"] {
        -moz-appearance: textfield;
    }
}

.minimum-time-checkbox-title {
    margin: 0;
}

.minimum-time-error {
    font-size: 12px;
}
</style>
